module.exports = __webpack_public_path__ + "static/media/vertical line 1.815de891.svg";